<template>
  <div class="scan-open-door">
    <main class="main-content">
      <h2 class="section-title">订单序号取货</h2>
      
      <!-- 订单类型切换 -->
            <div class="content-container">
              <div class="order-type-switch">
                <button 
                  class="type-btn" 
                  :class="{ active: orderType === 2 }"
                  @click="switchOrderType(2)"
                >
                  即时单
                </button>
                <button 
                  class="type-btn" 
                  :class="{ active: orderType === 1 }"
                  @click="switchOrderType(1)"
                >
                  预约单
                </button>
              </div>
              <span class="order-type-hint">预订单请点击此按钮</span>
            </div>

      <div class="content-container">
        <div class="store-info soft-pink-bg">
          <p class="store-note">#3号单请输入 3<br>如您有多个订单，请按 1 3 5 格式输入</p>
        </div>
      </div>

      <div class="content-container" ref="inputContainer">
        <div class="input-area light-grey-bg">
          <p class="input-prompt">请输入
          <span class="platform-name meituan-text">美团</span>
           <strong>订单序号</strong></p>
            <p v-if="orderType === 1" class="reservation-hint">预约单请输入完整序号，如 1-0831</p>
          <div v-if="step === 1" class="step-container">
            <div class="input-group">
              <div class="input-container">
                <div class="input-with-symbol">
                  <span class="prefix-symbol">#</span>
                  <input v-model="daySeqInput" type="text" class="dayseq-input" maxlength="15" @input="validateInput"
                    @focus="handleInputFocus">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      
      <div class="content-container" ref="elemeInputContainer">
        <div class="input-area light-grey-bg">
          <p class="input-prompt">请输入
          <span class="platform-name eleme-text">饿了么</span> 
          <strong>订单序号</strong></p>
           <p v-if="orderType === 1" class="reservation-hint">预约单请输入完整序号，如 1-0831</p>
          <div v-if="step === 1" class="step-container">
            <div class="input-group">
              <div class="input-container">
                <div class="input-with-symbol">
                  <span class="prefix-symbol">#</span>
                  <!-- 修改3：使用独立的数据属性 elemeDaySeqInput -->
                  <input v-model="elemeDaySeqInput" type="text" class="dayseq-input" maxlength="15" @input="validateElemeInput"
                    @focus="handleInputFocus">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 统一的按钮容器 -->
            <div class="content-container button-container">
              <div v-if="step === 1" class="step-container">
                <button class="confirm-btn" :disabled="!isAnyInputValid" @click="handleUnifiedConfirm">
                  {{ loading ? '查询中...' : '确定' }}
                </button>
              </div>
            </div>
      
      

      <!-- 第二步内容 -->
      <div v-if="step === 2" class="step-container">
        <h2 class="section-title">选择骑手姓氏</h2>
        <p class="hint-text">{{ daySeq }} 号单的骑手姓氏是：</p>

        <div class="surname-grid">
          <div v-for="(surname, index) in surnameOptions" :key="index" class="surname-item"
            @click="selectSurname(surname)">
            {{ surname }}
          </div>
        </div>
      </div>

      <p v-if="error" class="error-message">{{ error }}</p>
    </main>
  </div>
</template>
<script>
  export default {
    name: 'OrderQuery',
    data() {
      return {
        step: 1, // 当前步骤
        // 订单类型：1-预约单，2-即时单
        orderType: 2, // 默认为即时单
        daySeqInput: '', // 用户输入的订单序号字符串
        daySeqs: [], // 处理后的订单序号数组
        riderNames: [], // 骑手姓名列表
        surnameOptions: [], // 九宫格姓氏选项
        selectedSurname: '', // 选中的姓氏
        phoneLastFour: '', // 手机号后四位
        preOrderSeq: '',
        preOrderDate: null,
        isPreOrder: false,
        isValid: false, // 输入是否有效
        loading: false, // 加载状态
        error: '', // 错误信息
        lightColor: {
          name: '',
          hex: '#FFFFFF'
        },
        orderData: null, // 订单信息
        openToken: '', // 新增：开门令牌
        currentToken: null,
        orderTokens: {},
        expireTimer: null, // 新增：令牌过期计时器
        shopId: null,
        isKeyboardOpen: false,
        processing: false, // 处理状态
        // 订单状态跟踪
        orderStatuses: [],
        totalOrders: 0,
        completedOrders: 0,
        progress: 0,
        ptype: '',
        // 饿了么相关数据
            elemeDaySeqInput: '',
            elemeDaySeqs: [],
            isElemeValid: false,
            elemeLoading: false
      }
    },
    created() {
      // 解析URL参数获取shopId
      this.parseUrlParams();
    },
    computed: {
        // 检查是否有任一输入框有有效输入
        isAnyInputValid() {
          return this.isValid || this.isElemeValid;
        }
      },
    

    methods: {
      
      switchOrderType(type) {
              this.orderType = type;
              // 清空输入
              this.daySeqInput = '';
              this.elemeDaySeqInput = '';
              this.isValid = false;
              this.isElemeValid = false;
              this.error = '';
            },
      
      
    //   validateInput() {
    //     try {
    //       // 1. 获取并过滤输入值
    //       let filteredValue = this.daySeqInput.replace(/[^\d\s]/g, '');

    //       // 2. 更新显示的值（保留过滤后的内容）
    //       this.daySeqInput = filteredValue;

    //       // 3. 处理空格：移除开头和结尾的空格，保留内部空格
    //       const trimmedValue = filteredValue.trim();

    //       // 4. 验证逻辑：只要包含至少一个数字就有效
    //       this.isValid = /\d/.test(trimmedValue);
    

    //       // 5. 存储处理后的值（用于后续处理）
    //       this.daySeq = trimmedValue;

    //       // 6. 清除错误信息
    //       this.error = '';

    //     } catch (err) {
    //       console.error('输入验证错误:', err);
    //       this.error = '输入格式错误';
    //       this.isValid = false;
    //     }
    //   },
      
      validateElemeInput() {
        try {
          // 1. 获取并过滤输入值
          let filteredValue = this.elemeDaySeqInput.replace(/[^\d\s-]/g, '');
      
          // 2. 更新显示的值（保留过滤后的内容）
          this.elemeDaySeqInput = filteredValue;
      
          // 3. 处理空格：移除开头和结尾的空格，保留内部空格
          const trimmedValue = filteredValue.trim();
      
          // 4. 验证逻辑：只要包含至少一个数字就有效
          //this.isElemeValid = /\d/.test(trimmedValue);
          let isValid = false;
          //let daySeq = trimmedValue;
          
          if (trimmedValue) {
              // 检查是否匹配 "数字-数字" 格式
              const dashPattern = /^\d+-\d+$/;
              if (dashPattern.test(trimmedValue)) {
                  isValid = true;
                  // 解析预订单日期和序号
                  const parts = trimmedValue.split('-');
                  // parts[0] 是序号，parts[1] 是日期
                  this.elemeDaySeqs = parts[0];   // 如 "1"
                  this.preOrderDate = parts[1];  // 如 "0831"
                  this.isPreOrder = true;
              } 
              // 检查是否包含至少一个数字（纯数字格式）
              else if (/\d/.test(trimmedValue)) {
                  isValid = true;
                  this.elemeDaySeqs = trimmedValue;
                  this.preOrderDate = null;
                  this.isPreOrder = false;
              }
          }
                
          this.isElemeValid = isValid;
          
          // 5. 存储处理后的值（用于后续处理）
          //this.elemeDaySeqs = trimmedValue;
      
          // 6. 清除错误信息
          this.error = '';
      
        } catch (err) {
          console.error('输入验证错误:', err);
          this.error = '输入格式错误';
          this.isElemeValid = false;
        }
      },
      
      validateInput() {
          try {
              // 1. 获取并过滤输入值：允许数字、空格和横杠(-)
              let filteredValue = this.daySeqInput.replace(/[^\d\s-]/g, '');
      
              // 2. 更新显示的值（保留过滤后的内容）
              this.daySeqInput = filteredValue;
      
              // 3. 处理空格：移除开头和结尾的空格，保留内部空格
              const trimmedValue = filteredValue.trim();
      
              // 4. 验证逻辑：支持两种格式
              //    - 纯数字：如 "123"
              //    - 数字-数字：如 "1-0831"
              let isValid = false;
              //let daySeq = trimmedValue;
              
              if (trimmedValue) {
                  // 检查是否匹配 "数字-数字" 格式
                  const dashPattern = /^\d+-\d+$/;
                  if (dashPattern.test(trimmedValue)) {
                      isValid = true;
                      // 解析预订单日期和序号
                      const parts = trimmedValue.split('-');
                      // parts[0] 是序号，parts[1] 是日期
                      this.daySeq = parts[0];   // 如 "1"
                      this.preOrderDate = parts[1];  // 如 "0831"
                      this.isPreOrder = true;
                  } 
                  // 检查是否包含至少一个数字（纯数字格式）
                  else if (/\d/.test(trimmedValue)) {
                      isValid = true;
                      this.daySeq = trimmedValue;
                      this.preOrderDate = null;
                      this.isPreOrder = false;
                  }
              }
      
              this.isValid = isValid;
      
              // 5. 存储处理后的值（用于后续处理）
              //this.daySeq = trimmedValue;
      
              // 6. 清除错误信息
              this.error = '';
      
          } catch (err) {
              console.error('输入验证错误:', err);
              this.error = '输入格式错误';
              this.isValid = false;
          }
      },

      scrollToInput() {
        // 使用setTimeout确保在键盘弹出后执行
        setTimeout(() => {
          if (this.$refs.buttonContainer) {
            this.$refs.buttonContainer.scrollIntoView({
              behavior: 'smooth',
              block: 'end'
            });
          }
        }, 300);
      },

      // 解析URL参数
      parseUrlParams() {
        const urlParams = new URLSearchParams(window.location.search);
        this.shopId = urlParams.get('shopId');
        //this.shopId = "32223799";

        if (!this.shopId) {
          console.error('未找到shopId参数');
          // 可以添加错误处理，如显示错误提示或重定向
          this.error = '无效的店铺ID，请通过正确的入口访问';
        }
      },
      
      // 统一的确认处理方法
          handleUnifiedConfirm() {
            // 判断哪个输入框有值
            if (this.daySeqInput && this.daySeqInput.trim()) {
              // 美团订单处理
              this.processMultipleOrders();
            } else if (this.elemeDaySeqInput && this.elemeDaySeqInput.trim()) {
              // 饿了么订单处理
              this.handleMultipleOrders('eleme');
            } else {
              // 理论上不会执行到这里，因为按钮已禁用
              this.$message.warning('请输入订单序号');
            }
          },

      // 处理多个订单
      async processMultipleOrders() {
        if (!this.daySeq || !this.isValid) return;

        this.processing = true;
        this.error = '';
        this.successMessage = '';


        try {
          // 1. 分割订单序号为数组
          const daySeqs = this.daySeq.split(/\s+/).filter(seq => seq.trim() !== '');

          if (daySeqs.length === 0) {
            throw new Error('请输入有效的订单序号');
          }
          this.totalOrders = daySeqs.length;
          this.completedOrders = 0;
          this.progress = 0;

          // 2. 申请开门令牌（多个订单使用同一个令牌）
          this.openToken = await this.requestOpenToken(daySeqs, this.shopId);

          // 2. 批量获取所有订单数据
          
          const response = await this.fetchMultipleOrders(daySeqs, this.shopId, this.openToken,this.orderType,this.preOrderDate);

          const allOrders = response.orderDetails || [];
          this.totalOrders = allOrders.length;
          this.completedOrders = 0;

          const allOrdersData = [];
          let storeIdToOpen = null;
          let openTokenToUse = this.openToken;

          // 3. 逐个处理订单（顺序执行保证灯色切换）
          for (const order of allOrders) {
            try {
              this.updateOrderStatus(order.daySeq, 'processing', '开始亮灯');
              const processedOrder = this.processOrderData(order);
              // 处理当前订单数据
              //this.processOrderData(order); // 更新this.orderData

              if (!storeIdToOpen && order.storeId) {
                storeIdToOpen = order.storeId;
              }
              // 亮灯操作（不同订单不同颜色）
              const locationCodes = order.items.map(i => i.sheltNumber).join(',');
              
              let currentLightColor = {};
              if (order.storeId && locationCodes) {
                const lightResult = await this.controlLights(order.storeId, locationCodes);
                currentLightColor = {
                  name: lightResult.color,
                  hex: lightResult.hexCode || this.getColorHex(lightResult.color)
                };
              }

              allOrdersData.push({
                orderData: processedOrder,
                lightColor: currentLightColor
              });

              this.updateOrderStatus(order.daySeq, 'success', '处理完成');
            } catch (err) {
              this.updateOrderStatus(order.daySeq, 'error', `亮灯失败: ${err.message}`);
              throw err; // 中断后续处理
            } finally {
              this.completedOrders++;
            }
          }

          await this.navigateToOrderView(allOrdersData);

          // 5. 执行开门操作（不需要等待，可以并行执行）
          if (storeIdToOpen) {
            // 使用 async 但不等待，让它在后台执行
            this.confirmOpenDoor(storeIdToOpen, openTokenToUse);
          }

        } catch (err) {
          this.error = err.message || "订单处理失败，请重试";
          console.error('处理订单错误:', err);
        } finally {
          this.processing = false;
          this.buttonText = '确认并处理订单';
        }
      },

      async fetchMultipleOrders(daySeqs, shopId, openToken,orderType) {
        try {
          const url = `/api/orders?daySeqs=${daySeqs.join(',')}&shopId=${shopId}&openToken=${openToken}&orderType=${orderType}`;
          const response = await fetch(url, {
            headers: {
              'Accept': 'application/json'
            }
          });

          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || "批量查询订单失败");
          }
          const data = await response.json();
          console.group('后端返回的数据详情');
              console.log('完整数据:', data);
              console.log('数据类型:', typeof data);
              console.log('订单数量:', data.orderDetails?.length);
              
              if (data.orderDetails && data.orderDetails.length > 0) {
                console.log('第一个订单:', data.orderDetails[0]);
                console.log('第一个订单的items:', data.orderDetails[0].items);
                
                // 专门查看 sheltNumber 字段
                data.orderDetails.forEach((order, orderIdx) => {
                  console.log(`订单${orderIdx + 1}的库位码详情:`);
                  order.items.forEach((item, itemIdx) => {
                    console.log(`  商品${itemIdx + 1}: sheltNumber = "${item.originalSheltNumber}", 类型 = ${typeof item.sheltNumber}`);
                  });
                });
              }
              console.groupEnd();
          return data; // 返回订单数组
        } catch (err) {
          console.error('批量查询订单失败:', err);
          throw err;
        }
      },
      
      // 处理多个订单
      async handleMultipleOrders(platform) {
        if (platform === 'eleme'){
          this.ptype = 'E';
        if (!this.elemeDaySeqs || !this.isElemeValid) return;
      
        this.processing = true;
        this.error = '';
        this.successMessage = '';
      
      
        try {
          // 1. 分割订单序号为数组
          const daySeqs = this.elemeDaySeqs.split(/\s+/).filter(seq => seq.trim() !== '');
      
          if (daySeqs.length === 0) {
            throw new Error('请输入有效的订单序号');
          }
          this.totalOrders = daySeqs.length;
          this.completedOrders = 0;
          this.progress = 0;
      
          // 2. 申请开门令牌（多个订单使用同一个令牌）
          this.openToken = await this.genOpenToken(daySeqs, this.shopId,this.ptype);
      
          // 2. 批量获取所有订单数据
          const response = await this.queryMultipleOrders(daySeqs, this.shopId, this.openToken,this.ptype,this.orderType,this.preOrderDate);
      
          const allOrders = response.orderDetails || [];
          this.totalOrders = allOrders.length;
          this.completedOrders = 0;
      
          const allOrdersData = [];
          let storeIdToOpen = null;
          let openTokenToUse = this.openToken;
      
          // 3. 逐个处理订单（顺序执行保证灯色切换）
          for (const order of allOrders) {
            try {
              this.updateOrderStatus(order.daySeq, 'processing', '开始亮灯');
              const processedOrder = this.processOrderData(order);
              // 处理当前订单数据
              //this.processOrderData(order); // 更新this.orderData
      
              if (!storeIdToOpen && order.storeId) {
                storeIdToOpen = order.storeId;
              }
              // 亮灯操作（不同订单不同颜色）
              const locationCodes = order.items.map(i => i.sheltNumber).join(',');
              let currentLightColor = {};
              if (order.storeId && locationCodes) {
                const lightResult = await this.controlLights(order.storeId, locationCodes);
                currentLightColor = {
                  name: lightResult.color,
                  hex: lightResult.hexCode || this.getColorHex(lightResult.color)
                };
              }
      
              allOrdersData.push({
                orderData: processedOrder,
                lightColor: currentLightColor
              });
      
              this.updateOrderStatus(order.daySeq, 'success', '处理完成');
            } catch (err) {
              this.updateOrderStatus(order.daySeq, 'error', `亮灯失败: ${err.message}`);
              throw err; // 中断后续处理
            } finally {
              this.completedOrders++;
            }
          }
      
          await this.navigateToOrderView(allOrdersData);
      
          // 5. 执行开门操作（不需要等待，可以并行执行）
          if (storeIdToOpen) {
            // 使用 async 但不等待，让它在后台执行
            this.confirmOpenDoor(storeIdToOpen, openTokenToUse);
          }
      
        } catch (err) {
          this.error = err.message || "订单处理失败，请重试";
          console.error('处理订单错误:', err);
        } finally {
          this.processing = false;
          this.buttonText = '确认并处理订单';
          this.ptype = '';
        }
        }
      },
      
      async queryMultipleOrders(daySeqs, shopId, openToken,pType,orderType) {
        try {
          const url = `/api/orders/fetch-order?daySeqs=${daySeqs.join(',')}&shopId=${shopId}&openToken=${openToken}&pType=${pType}&orderType=${orderType}`;
          const response = await fetch(url, {
            headers: {
              'Accept': 'application/json'
            }
          });
      
          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || "批量查询订单失败");
          }
          const data = await response.json();
          return data; // 返回订单数组
        } catch (err) {
          console.error('批量查询订单失败:', err);
          throw err;
        }
      },

      // 处理单个订单
      async processSingleOrder(daySeq, openToken) {
        try {
          // 更新状态为处理中
          this.updateOrderStatus(daySeq, 'processing', '开始处理订单');

          // 1. 获取订单信息
          //const orderInfo = await this.fetchOrderInfo(daySeq, this.shopId, openToken);
          await this.fetchOrderInfo(daySeq, this.shopId, openToken);

          // 2. 更新订单状态
          this.updateOrderStatus(daySeq, 'processing', '获取订单详情成功');

          // 3. 标记订单处理成功
          this.updateOrderStatus(daySeq, 'success', '订单处理完成');
          this.completedOrders++;

        } catch (err) {
          this.updateOrderStatus(daySeq, 'error', `处理失败: ${err.message}`);
          this.completedOrders++;
          throw err;
        }
      },

      // 获取单个订单信息
      async fetchOrderInfo(daySeq, shopId, openToken) {
        try {
          const url = `/api/orders?daySeq=${daySeq}&shopId=${shopId}&openToken=${openToken}`;
          alert("fetchOrderInfo")
          const response = await fetch(url, {
            headers: {
              'Accept': 'application/json'
            }
          });

          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || "查询订单信息失败");
          }

          const orderData = await response.json();

          // 2. 处理订单数据
          this.processOrderData(orderData);

          // 3. 执行亮灯操作并等待完成
          const locationCodes = this.orderData.items
            .map(item => item.sheltNumber)
            .join(",");

          if (this.orderData.storeId && locationCodes) {
            // 等待亮灯操作完成
            const lightResult = await this.controlLights(this.orderData.storeId, locationCodes);

            // 保存颜色信息
            if (lightResult) {
              this.lightColor = {
                name: lightResult.color,
                hex: lightResult.hexCode || this.getColorHex(lightResult.color)
              };
            }
          }
        } catch (err) {
          console.error('获取订单信息失败:', err);
          throw new Error(`查询订单信息失败: ${err.message}`);
        }
      },

      // 更新订单状态
      updateOrderStatus(daySeq, state, message, data = {}) {
        const statusIndex = this.orderStatuses.findIndex(s => s.daySeq === daySeq);
        if (statusIndex !== -1) {
          this.orderStatuses[statusIndex].state = state;
          this.orderStatuses[statusIndex].message = message;

          if (data.user) this.orderStatuses[statusIndex].user = data.user;
          if (data.address) this.orderStatuses[statusIndex].address = data.address;
          if (data.shelves) this.orderStatuses[statusIndex].shelves = data.shelves;

          // 确保Vue更新DOM
          this.$set(this.orderStatuses, statusIndex, {
            ...this.orderStatuses[statusIndex]
          });
        }
      },

      // 获取骑手信息
      async fetchRiderInfo() {
        if (!this.daySeq) return;

        this.loading = true;
        this.error = '';

        try {
          // 1. 申请开门令牌
          const tokenResponse = await this.requestOpenToken(this.daySeq, this.shopId);
          if (tokenResponse.length > 0) {
            this.openToken = tokenResponse[0].openToken; // 取第一个令牌
            //alert(this.openToken);

            // 2. 获取骑手信息
            const url = `/api/orders/by-dayseq?daySeq=${this.daySeq}&shopId=${this.shopId}`;
            const response = await fetch(url, {
              headers: {
                'Accept': 'application/json'
              }
            });

            if (!response.ok) {
              const error = await response.json();
              throw new Error(error.message || "查询骑手信息失败");
            }

            const data = await response.json();
            //alert(data.riderNames)
            this.riderNames = data.riderNames || [];

            // 3. 生成九宫格姓氏选项
            this.generateSurnameOptions();
            this.step = 2;
          } else {
            alert("未获取到有效的开门令牌");
          }

        } catch (err) {
          this.error = err.message || "操作失败，请重试";
        } finally {
          this.loading = false;
        }
      },

      handleInputFocus() {
        // 针对iOS的特殊处理
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

        if (isIOS) {
          // iOS设备使用定时器+固定滚动距离
          setTimeout(() => {
            const inputRect = this.$refs.inputContainer.getBoundingClientRect();
            const scrollY = window.scrollY + inputRect.top - 100; // 上移100px留出键盘空间

            window.scrollTo({
              top: scrollY,
              behavior: 'smooth'
            });
          }, 300);
        } else {
          // 安卓保持原有逻辑
          setTimeout(() => {
            const inputElement = document.querySelector('.dayseq-input');
            if (inputElement) {
              inputElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }
          }, 300);
        }
      },

      handleResize() {
        // 检测是否是键盘弹出引起的窗口高度变化
        if (this.isKeyboardOpen && window.innerHeight < 500) {
          // 键盘弹出时调整按钮位置
          this.$nextTick(() => {
            if (this.$refs.inputContainer) {
              this.$refs.inputContainer.scrollIntoView({
                behavior: 'auto',
                block: 'center'
              });
            }
          });
        }
      },

      handleInputBlur() {
        this.isKeyboardOpen = false;
      },

      scrollToButton() {
        // 等待一小段时间确保键盘已经弹出
        setTimeout(() => {
          if (this.$refs.buttonContainer) {
            // 计算按钮位置
            const buttonRect = this.$refs.buttonContainer.getBoundingClientRect();
            const scrollPosition = buttonRect.top + window.scrollY - 100;

            // 平滑滚动到按钮上方
            window.scrollTo({
              top: scrollPosition,
              behavior: 'smooth'
            });
          }
        }, 300);
      },

      // 申请开门令牌（多个订单）
      async requestOpenToken(daySeqs, shopId) {
        try {
          // 将多个订单序号转为逗号分隔的字符串
          const daySeqStr = daySeqs.join(',');
          const url = `/api/orders/request-token?daySeq=${encodeURIComponent(daySeqStr)}&shopId=${shopId}`;

          const response = await fetch(url, {
            method: 'POST'
          });

          if (!response.ok) {
            throw new Error('获取令牌失败');
          }

          const result = await response.json();
          return result.token; // 假设返回 {token: "xxxx"}

        } catch (err) {
          console.error('令牌请求失败:', err);
          throw new Error(`获取令牌失败: ${err.message}`);
        }
      },
      
      async genOpenToken(daySeqs, shopId,pType) {
        try {
          // 将多个订单序号转为逗号分隔的字符串
          const daySeqStr = daySeqs.join(',');
          const url = `/api/orders/generate-token?daySeq=${encodeURIComponent(daySeqStr)}&shopId=${shopId}&pType=${pType}`;
      
          const response = await fetch(url, {
            method: 'POST'
          });
      
          if (!response.ok) {
            throw new Error('获取令牌失败');
          }
      
          const result = await response.json();
          return result.token; // 假设返回 {token: "xxxx"}
      
        } catch (err) {
          console.error('令牌请求失败:', err);
          throw new Error(`获取令牌失败: ${err.message}`);
        }
      },

      

      // 生成九宫格姓氏选项
      generateSurnameOptions() {
        const commonSurnames = ['王', '李', '张', '刘', '陈', '杨', '赵', '黄', '周', '吴'];
        const actualSurnames = this.riderNames.map(name => name.charAt(0));

        // 确保选项包含实际姓氏
        this.surnameOptions = [...new Set([...actualSurnames])];

        // 填充到9个选项
        while (this.surnameOptions.length < 9) {
          const randomSurname = commonSurnames[
            Math.floor(Math.random() * commonSurnames.length)
          ];

          if (!this.surnameOptions.includes(randomSurname)) {
            this.surnameOptions.push(randomSurname);
          }
        }

        // 随机排序
        this.surnameOptions = this.surnameOptions
          .sort(() => Math.random() - 0.5)
          .slice(0, 9);
      },

      // 选择姓氏
      async selectSurname(surname) {
        this.selectedSurname = surname;

        try {
          // 1. 查询订单详情
          const url =
            `/api/orders?daySeq=${this.daySeq}&riderName=${surname}&openToken=${this.openToken}&shopId=${this.shopId}`;
          const response = await fetch(url);

          if (!response.ok) {
            throw new Error('订单查询失败');
          }

          const orderData = await response.json();

          // 2. 处理订单数据
          this.processOrderData(orderData);

          // 3. 执行亮灯操作并等待完成
          const locationCodes = this.orderData.items
            .map(item => item.sheltNumber)
            .join(",");

          if (this.orderData.storeId && locationCodes) {
            // 等待亮灯操作完成
            const lightResult = await this.controlLights(this.orderData.storeId, locationCodes);

            // 保存颜色信息
            if (lightResult) {
              this.lightColor = {
                name: lightResult.color,
                hex: lightResult.hexCode || this.getColorHex(lightResult.color)
              };
            }
          }

          // 4. 导航到订单视图
          await this.navigateToOrderView();

          // 5. 执行开门操作（不需要等待，可以并行执行）
          if (this.orderData.storeId) {
            // 使用 async 但不等待，让它在后台执行
            this.confirmOpenDoor();
          }

        } catch (err) {
          this.error = err.message || "订单查询失败";
        }
      },


      // 修改后的订单查询（带令牌验证）
      async queryOrderInfoWithToken(phoneLast4, token) {
        try {
          // 1. 获取订单数据
          const url =
            `/api/orders?riderPhoneLast4=${encodeURIComponent(phoneLast4)}&openToken=${encodeURIComponent(token)}`;
          const response = await fetch(url, {
            headers: {
              'Accept': 'application/json'
            }
          });

          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || "查询订单失败");
          }

          const data = await response.json();
          this.processOrderData(data);
          this.openToken = token;

          // 2. 执行亮灯操作并等待完成
          const locationCodes = this.orderData.items
            .map(item => item.sheltNumber)
            .join(",");

          if (this.orderData.storeId && locationCodes) {
            // 等待亮灯操作完成
            const lightResult = await this.controlLights(this.orderData.storeId, locationCodes);

            // 保存颜色信息
            if (lightResult) {
              this.lightColor = {
                name: lightResult.color,
                hex: lightResult.hexCode || this.getColorHex(lightResult.color)
              };
            }
          }

          // 3. 导航到订单视图（此时颜色信息已准备好）
          await this.navigateToOrderView();

          // 4. 执行开门操作（不需要等待，可以并行执行）
          if (this.orderData.storeId) {
            // 使用 async 但不等待，让它在后台执行
            this.confirmOpenDoor();
          }

        } catch (error) {
          console.error('订单查询错误:', error);
          //alert(`查询失败: ${error.message}`);
          throw error;
        }
      },

     

      processOrderData(order) {
        // 处理订单数据，返回一个新的对象
        return {
          orderId: order.orderId,
          shopAddress: order.shopAddress,
          shopName: order.shopName,
          orderPattern: order.orderPattern,
          storeId: order.storeId,
          //totalCount: order.items.reduce((total, item) => total + item.itemQuantity, 0),
          totalCount: order.totalCount,
          pType: order.ptype,
          items: order.items.map(item => ({
            id: item.id,
            itemName: item.itemName,
            originalSheltNumber: item.originalSheltNumber || item.sheltNumber, 
            sheltNumber: item.sheltNumber,
            itemQuantity: item.itemQuantity,
            imageUrl: item.imageUrl,
            status: 'pending' // 初始状态
          }))
        };
      },

      // 控制灯光方法
      async controlLights(storeId, locationCodes) {
        try {
          const url =
            `/api/device/send-command?storeId=${storeId}&locationCodes=${encodeURIComponent(locationCodes)}`;
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Accept': 'application/json'
            }
          });

          if (!response.ok) {
            console.error('灯控请求失败:', await response.text());
          } else {
            const result = await response.json();
            console.log('灯控指令发送成功:', locationCodes, '颜色信息:', result.color);

            return {
              color: result.color,
              hexCode: result.hexCode
            };
          }
        } catch (err) {
          console.error('灯控异常:', err);
          return null;
        }
      },

      getColorHex(colorName) {
        const colorMap = {
          '红色': '#FF0000',
          '绿色': '#00FF00',
          '蓝色': '#0000FF',
          '紫色': '#FF00FF',
          '黄色': '#FFFF00'

        };
        return colorMap[colorName] || '#FFFFFF';
      },

      async navigateToOrderView(orderData) {
        try {
          const randomKey = Math.random().toString(36).slice(2);

          sessionStorage.setItem(randomKey, JSON.stringify({
            orders: orderData // 存储所有订单数据（包含每个订单的颜色）
          }));
          //sessionStorage.setItem(randomKey, JSON.stringify(this.orderData));
          //sessionStorage.setItem(randomKey, JSON.stringify(storageData));
          await this.$router.push({
            name: 'OrderView',
            query: {
              key: randomKey
            },
          });
          //console.log('存储的颜色信息:', this.lightColor);
        } catch (err) {
          console.error('路由跳转失败:', err);
          throw new Error("页面跳转异常");
        }
      },

      // 修改后的开门方法（带令牌验证）
      async confirmOpenDoor(storeId, openToken) {
        this.loading = true;

        let tokenToUse = openToken;
        if (!tokenToUse) {
          console.warn("尝试开门但 openToken 为空");

          // 尝试使用当前令牌作为后备
          const backupToken = this.currentToken || (this.orderTokens[storeId] || "");

          if (!backupToken) {
            throw new Error("无法确定有效的开门令牌");
          }

          tokenToUse = backupToken;
        }

        try {
          const response = await fetch("/api/orders/confirm-open", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              openToken: openToken,
              storeId: storeId
            }),
            credentials: "include"
          });

          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || "开门请求失败");
          }
          const result = await response.json();
          alert(result.message || "开门操作成功！");
        } catch (err) {
          alert(err.message || "开门操作失败");
          throw err; // 继续向上抛出
        } finally {
          this.loading = false;
        }
      },

      // 新增：令牌过期处理
      startTokenExpireTimer() {
        this.clearTimer();
        this.expireTimer = setTimeout(() => {
          this.openToken = '';
          alert('操作已超时（2分钟），请重新扫码');
        }, 2 * 60 * 1000); // 2分钟有效期
      },

      clearTimer() {
        if (this.expireTimer) {
          clearTimeout(this.expireTimer);
          this.expireTimer = null;
        }
      }
    },

    beforeUnmount() {
      this.clearTimer();
    }
  }
</script>

<style scoped>
  /* 全局样式 */
  * {
    font-family: 'SourceHanSansSC-Normal', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  /*2026-09-06 add*/
  .reservation-hint {
    color: #ff6b35;
    font-size: 18px;
    font-weight: 500;
    margin: 4px 0 8px 0;
    padding-left: 4px;
  }
  
  .order-type-hint {
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
    margin-left: 148px;
  }
  /*2026-09-06*/
  
  /*2026-08-04 add*/
  .order-type-switch {
    display: flex;
    gap: 10px;
    justify-content: center;
    padding: 10px 0;
  }
  
  .type-btn {
    padding: 8px 24px;
    border: 2px solid #ddd;
    border-radius: 20px;
    background: white;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s ease;
  }
  
  .type-btn.active {
    border-color: #ff6b6b;
    background: #ff6b6b;
    color: white;
  }
  
  .type-btn:hover:not(.active) {
    border-color: #ff6b6b;
    color: #ff6b6b;
  }
  /*2026-08-04 */

  /* 页面容器 */
  .scan-open-door {
    background-image: url('~@/assets/images/background.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    max-width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    color: white;
    position: relative;
    z-index: 1;
    padding: 20px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: calc(20px + env(safe-area-inset-bottom));
    box-sizing: border-box;
  }

  .step-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 20px;
    text-align: center;
  }

  .button-container {
    transition: transform 0.3s ease;
    margin-top: auto;
    /* 将按钮推到内容底部 */
    padding-bottom: env(safe-area-inset-bottom);
    /* 安全区域 */
  }

  .is-input-focused .button-container {
    position: fixed;
    bottom: calc(20px + env(safe-area-inset-bottom));
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 600px;
    z-index: 100;
    padding: 0 20px;
    box-sizing: border-box;
  }


  .content-container {
    width: 100%;
    max-width: 600px;
    /* 可以调整这个值来控制最大宽度 */
    margin: 0 auto 20px;
    /* 居中并添加底部间距 */
  }

  .dayseq-input {
    flex: 1;
    width: 100%;
    padding: 15px 10px;
    border: none;
    outline: none;
    font-size: 35px;
    background-color: transparent;
    z-index: 1;
    /* 确保在#号上方 */
  }

  /* 添加底部安全区域 */
  .content-container:last-child {
    padding-bottom: env(safe-area-inset-bottom);
  }

  /* 确保输入框在获得焦点时保持可见 */
  .dayseq-input:focus {
    border-color: #ff4081;
    box-shadow: 0 0 0 2px rgba(255, 64, 129, 0.2);
  }


  /* 响应式调整 - 小屏幕设备 */
  @media (max-height: 700px) {
    .scan-open-door {
      padding: 10px;
    }

    .content-container {
      margin-bottom: 10px;
    }



    .confirm-btn {
      height: 50px;
      font-size: 18px;
    }
  }

  .dayseq-input::placeholder {
    color: #999;
  }

  .phone-container {
    background: linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 0%,
        rgba(255, 255, 255, 0.1) 100%);
    backdrop-filter: blur(4px);

    width: 55px;
    /* 缩小手机宽度 */
    height: 100px;
    /* 缩小手机高度 */
    margin: 20px auto;
    /* 增加外边距 */
    position: relative;
    margin: 50px auto 0;

  }

  .phone-outline {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* 保持比例裁剪 */
    background: #fff;
  }

  .qrcode-inside {
    width: 50px;
    /* 二维码宽度 */
    height: 50px;
    /* 二维码高度 */
    top: 50px;
    /* 上移位置 */
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    padding: 8px;
    /* 减少内边距 */
    top: 50px;
  }

  .phone-illustration {
    width: 80px;
    height: 160px;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
  }

  .phone-image {
    width: 100%;
    height: auto;
  }

  /* 主要内容区域 */
  .main-content {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(8px);
    z-index: 2;

    flex: 1;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100%;
    padding-bottom: 100px;
  }

  /* 分区标题 */
  .section-title {
    font-size: 26px;
    color: black;
    margin-bottom: 30px;
    font-weight: 800;
  }

  /* 二维码容器 */
  .qr-code-container {
    margin-bottom: 30px;
  }

  .qr-code-icon {
    width: 120px;
    height: 120px;
    background-color: white;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
  }

  .qr-code-placeholder {
    width: 100px;
    height: 100px;
    background-color: black;
  }

  /* 输入区域 */
  .input-section {
    width: 100%;
    max-width: 300px;
    margin-top: 40px;
  }

  .input-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 300px;
  }

  .input-label {
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 10px;
    text-align: center;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    font-family: 'SourceHanSansSC-Normal', sans-serif;
  }

  /* .input-container {
  width: 180px;
  height: 34px;
  background-color: #e0e0e0; 
  border-radius: 17px; 
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
} 
*/
  .input-container {
    width: 100%;
  }

  .phone-input {
    font-family: 'SourceHanSansSC-Normal', sans-serif;
    width: 80%;
    height: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    text-align: center;
    color: #333;
    background-color: transparent;
  }

  .phone-input::placeholder {
    color: #999;
  }


  .fixed-button {
    position: fixed;
    bottom: calc(20px + env(safe-area-inset-bottom));
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 600px;
    z-index: 100;
    padding: 0 20px;
    box-sizing: border-box;
    margin-bottom: 0;
  }


  /* 按钮样式 - 长条圆角按钮 */
  .confirm-btn {
    width: 100%;
    height: 60px;
    font-size: 20px;
    margin-top: 10px;
    background-color: #ff4081;
    /* 粉色主题按钮 */
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 12px;
    /* 圆角 */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  .confirm-btn:hover {
    background-color: #e91e63;
    /* 鼠标悬停时颜色加深 */
    transform: translateY(-2px);
  }

  .confirm-btn:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    transform: none;
  }

  .confirm-btn:not(:disabled):active {
    background-color: #e0e0e0;
  }

.platform-name {
  font-size: 1.2em; /* 放大字体 */
  font-weight: bold;
  margin: 0 4px;
}

/* 美团文字样式 - 黄色 */
.meituan-text {
  color: #FFBD00; /* 美团黄 */
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.2); /* 添加轻微阴影增强可读性 */
}

/* 饿了么文字样式 - 蓝色 */
.eleme-text {
  color: #0099FF; /* 饿了么蓝 */
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.2); /* 添加轻微阴影增强可读性 */
}

  /* 键盘打开时的整体布局调整 */
  .keyboard-open {
    padding-bottom: 200px;
    /* 为键盘留出空间 */
  }

  /* 底部说明 */
  .footer-note {
    font-size: 15px;
    color: #ffffff;
    text-align: center;
    margin: 15px 0;
    margin-top: 20px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    font-family: 'SourceHanSansSC-Normal', sans-serif;
  }

  .error-message {
    color: #ff5252;
    font-size: 18px;
    text-align: center;
    margin-top: 15px;
  }

  .surname-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 15px;
    width: 100%;
  }

  .surname-item {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #ccc;
    border-radius: 10px;
    font-size: 24px;
    cursor: pointer;
  }

  .surname-item:hover {
    transform: translateY(-3px);
    /* 轻微上浮效果 */
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    background: #3498db;
    color: white;
  }

  .hint-text {
    font-size: 18px;
    color: #555;
    margin-top: 20px;
  }

  /* 添加左对齐样式 */
  .section-title,
  .store-note,
  .input-prompt,
  .input-group,
  .hint-text {
    text-align: left;
    width: 100%;
  }

  .input-prompt {
    font-size: 20px;
    margin-bottom: 10px;
    color: black;
    font-weight: bold;
  }

  /* 灰色背景 */
  .grey-bg {
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 10px;
  }

  /* 白色背景 */
  .white-bg {
    background-color: white;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 20px;
  }

  /* 柔和的粉色背景 */
  .soft-pink-bg {
    background-color: #fce4ec;
    /* 柔和的粉色 */
    border-radius: 12px;
    padding: 10px;
    margin-bottom: 10px;
  }

  /* 浅灰色背景 */
  .light-grey-bg {
    background-color: #f8f9fa;
    /* 浅灰色 */
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 10px;
  }

  /* 圆角按钮 */
  .rounded-btn {
    border-radius: 30px !important;
  }

  .store-note {
    font-size: 16px;
    line-height: 1.5;
    color: black;
  }

  /* 带符号的输入框样式 */
  .input-with-symbol {
    display: flex;
    align-items: center;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    padding-left: 40px;
    height: 60px;
  }

  .prefix-symbol {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    transition: opacity 0.3s;
    justify-content: center;
    justify-content: center;
    width: 40px;
    height: 100%;
    font-size: 36px;
    font-weight: bold;
    color: #000;
    background-color: white;
  }
</style>